<div class="header-content" @fade>
  <div class="logo">
    <img [src]="logoUrl" alt="Logo" />
    <!-- <img src="assets/logo/Clever-Artie.png" alt="Logo" /> -->
  </div>

  <h1 class="header-title">{{ heading }}</h1>
  <div class="header-subtitle" *ngIf="showSubheading != null">
    {{ subheading }}
  </div>
  <!-- Study smarter with Study Bru! -->
</div>
